import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { UtilsService } from "../../../../auth/service/utils.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { locale as italian } from "../../../../i18n/it";
import { AbsencesService } from "../../../../auth/service/absences.service";
import { AuthenticationService } from "../../../../auth/service";
import moment from "moment/moment";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { IAbsence, IUpdateAbsence } from "app/auth/models/absences";
import { ICurrentUser } from "app/auth/models/user-interface";

@Component({
  selector: "app-absence-requested-list",
  templateUrl: "./absence-requested-list.component.html",
  styleUrls: ["./absence-requested-list.component.scss"],
})
export class AbsenceRequestedListComponent implements OnInit {
  @Output() callbackFn: EventEmitter<any> = new EventEmitter();
  @ViewChild("viewAbsence") viewAbsenceModal: ElementRef;
  @ViewChild("noteRejectModal") noteRejectModal: ElementRef;
  public contentHeader: IContentHeader;
  public absence: IAbsence[];
  public tableLimit: number = 10;
  public searchKeyword: string = "";
  public searchStatus: number = 10;
  public currentAbsence: IAbsence = null;
  public me: ICurrentUser;
  public idFromNotifications: string = "";
  public rejectedNote: string = "";
  public typesList: string[] = [];
  public filteredAbsences: IAbsence[] = [];
  public availableMonths: string[] = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
  public selectedMonth: string = moment().format("M");
  public availableYears: string[] = [];
  public selectedYear: string = moment().format("YYYY");

  constructor(
    public _absenceService: AbsencesService,
    public _utilService: UtilsService,
    private _routerService: Router,
    public _modalService: NgbModal,
    public _authenticationService: AuthenticationService,
    public activatedRoute: ActivatedRoute,
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.idFromNotifications = params.id;
      const searchKey = params.search;
      const status = params.status;
      const month = params.month;
      const year = params.year;
      if (!!searchKey && searchKey != 0) {
        this.searchKeyword = searchKey;
      }
      if (!!status && Number(status) >= 0 && Number(status) < 3) {
        this.searchStatus = Number(status);
      }
      if (!!month && Number(month) > 0 && Number(month) <= 12) {
        this.selectedMonth = month;
      }
      if (!!year && Number(year) > 0) {
        this.selectedYear = year;
      }
    });

    this.contentHeader = {
      headerTitle: italian.data.ABSENCES_REQUESTED_LIST,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.MANAGE,
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: italian.data.ABSENCES_REQUESTED_LIST,
            isLink: false,
          },
        ],
      },
    };

    for (let i = 2023; i <= moment().year()+1; i++) {
      this.availableYears.push(String(i));
    }
  }

  async ngOnInit() {
    await this.loadAbsence();
    this.me = this._authenticationService.getCurrentUser();
    if (this.idFromNotifications) {
      this.openModal(this.viewAbsenceModal, Number(this.idFromNotifications));
    }
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  async loadAbsence() {
    const month: number = Number(this.selectedMonth);
    const year: number = Number(this.selectedYear);
    this.absence = await this._absenceService.getAbsencesList(month, year);

    const countPending: number = this.absence.filter((item: IAbsence) => item.status == 0).length;
    if (countPending > 0) {
      this.searchStatus = 0;
    }
    const approved: string = await this._utilService.translate("APPROVED_FEMALE_SINGULAR");
    const pending: string = await this._utilService.translate("PENDING");
    const notApproved: string = await this._utilService.translate("NOT_APPROVED_SINGULAR");
    const deleted: string = await this._utilService.translate("ABORTED");
    this.absence.map((item: IAbsence) => {
      if (item.status === 1) {
        item.enabled_label = approved;
      } else if (item.status === 2) {
        item.enabled_label = notApproved;
      } else if (item.status === 3) {
        item.enabled_label = deleted;
      } else {
        item.enabled_label = pending;
      }
    });

    this.typesList = this.absence
      .map((absence: IAbsence) => absence.type.name)
      .filter((value: string, index: number, self: string[]) => self.indexOf(value) === index)
      .sort();
    this.searchAbsences();
  }

  searchAbsences() {
    let items: IAbsence[] = this.absence;
    if (items) {
      items.sort((a, b) => (a.from < b.from ? 1 : a.from > b.from ? -1 : 0));
    }
    const keywords: string = this.searchKeyword.trim().toLowerCase();

    if (keywords.length > 0) {
      items = items.filter((item: IAbsence) => item.employee.complete_name.toLowerCase().includes(keywords) || item.type.name.toLowerCase().includes(keywords));
    }

    if (this.searchStatus < 3 && this.searchStatus >= 0) {
      items = items.filter((item: IAbsence) => Number(item.status) === Number(this.searchStatus));
    }

    this.filteredAbsences = items;
  }

  changeQueryParams() {
    const url = new URL(window.location.href);

    if (!!this.searchKeyword && this.searchKeyword.length >= 3) {
      url.searchParams.set("search", String(this.searchKeyword));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("search");
      history.pushState({}, "", url);
    }

    if (this.searchStatus < 3 && this.searchStatus >= 0) {
      url.searchParams.set("status", String(this.searchStatus));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("status");
      history.pushState({}, "", url);
    }

    if (!!this.selectedMonth && Number(this.selectedMonth) > 0 && Number(this.selectedMonth) <= 12) {
      url.searchParams.set("month", this.selectedMonth);
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("month");
      history.pushState({}, "", url);
    }

    if (!!this.selectedYear && Number(this.selectedYear) > 0) {
      url.searchParams.set("year", this.selectedYear);
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("year");
      history.pushState({}, "", url);
    }
  }

  getFormat(date, absence) {
    if (absence.type.category === "permesso") {
      return this._utilService.formatDate(date, "DD/MM/YY HH:mm");
    } else {
      return this._utilService.formatDate(date);
    }
  }

  async rejectAbsence(currentAbsence) {
    let data: IUpdateAbsence = { absences: [currentAbsence.id], status_note: null };
    data.status_note = this.rejectedNote;
    this._utilService.showLoading();
    await this._absenceService
      .updateRequestedAbsence("reject", data)
      .then(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALSuccess({ text: "SUCCESS_REJECT_ABSENCE" });
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_EDIT_ABSENCE" });
      });
    this.modalClose();
    await this.loadAbsence();
  }

  async toggleEnabled(currentAbsence, action) {
    if (!this._authenticationService.hasCapability("edit_others_absences")) {
      await this._routerService.navigateByUrl("/dashboard/main");
      return false;
    }
    let data: IUpdateAbsence = { absences: [currentAbsence.id] };
    if (action === "reject") {
      this._modalService.open(this.noteRejectModal, {
        centered: true,
        size: "sm",
        backdrop: false,
        keyboard: false,
      });
      return false;
    }
    this._utilService.showLoading();
    await this._absenceService
      .updateRequestedAbsence(action, data)
      .then(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALSuccess({ text: "SUCCESS_APPROVED_ABSENCE" });
        this.loadAbsence();
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_EDIT_ABSENCE" });
      });
  }

  modalClose() {
    this._modalService.dismissAll();
    this.rejectedNote = "";
    this.callbackFn.emit();
  }

  async openModal(modal, absenceId) {
    this.currentAbsence = null;
    if (!absenceId) return false;
    this.currentAbsence = await this._absenceService.getAbsence(absenceId);
    this._modalService.open(modal, {
      centered: true,
      size: "sm",
    });
  }

  loadAttachment(file: string) {
    return this._utilService.getFile(file);
  }

  formatLabel(month: number) {
    const date = moment();
    date.set("month", month - 1);
    return date.format("MMMM");
  }
}
